<script>
  import { ProductInfo } from "@retailer/svelte/Shared/ProductInfo.js";
  export let product;
  export let placeholderProduct;
  export let isAlreadyIncludedInList;
  export let onAddProductToList;
  export let onRemoveProductFromList;

</script>

<div
  data-product-id={product.id}
  class="media padding--small background-white box-shadow box-shadow--hover margin-bottom--small"
>
  <div class="media-fluid">
    <div class="default-subheader--bold">{ProductInfo(product)[0]}</div>
    <div class="default-subheader--regular">{ProductInfo(product)[1]}</div>
  </div>
  <div class="media-fixed align-right align-self-center">
    {#if isAlreadyIncludedInList}
      <button
        class="button button--alert button--smallest"
        on:click|preventDefault={() => onRemoveProductFromList(product)}
      >
        Remove
      </button>
    {:else}
      <button
        class="button button--primary button--smallest"
        on:click|preventDefault={() => onAddProductToList(product, placeholderProduct)}
      >
        Save to List
      </button>
    {/if}
  </div>
</div>
